import React,{useEffect,useState} from "react";
import sliderInner from '../assets/images/sliderInner.jpg';
import leafIcn from '../assets/images/slider-shape-5.png';
import { useNavigate } from "react-router-dom";
import subThemes from "../helper/SubThemes_List";
import savewatericon1 from"../assets/images/icon/homeIcons/theme6icon/icon-1.png";
import savewatericon2 from"../assets/images/icon/homeIcons/theme6icon/icon-2.png";
import savewatericon3 from"../assets/images/icon/homeIcons/theme6icon/icon-3.png";
import savewatericon4 from"../assets/images/icon/homeIcons/theme6icon/icon-4.png";
import savewatericon5 from"../assets/images/icon/homeIcons/theme6icon/icon-5.png";
import savewatericon6 from"../assets/images/icon/homeIcons/theme6icon/icon-6.png";

function SaveWater() {
  const navigate = useNavigate();
  const [themeData, setThemeData] = useState(null);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  scrollToTop()

  const handleRoute = (data) => {
    localStorage.setItem('sub_themes', subThemes['Save Water'][data].value);
    navigate('/details');
  };
  const fetchDetails = async (data) => {
    try {
      const response = await fetch(`https://ecoclubs.education.gov.in/api/get-participants-details?theme=Save Water`);
      console.log("response---------------------",response); // Replace with your API URL
      const result = await response.json();
      console.log("result---------------------",result);
      setThemeData(result?.data); // Store fetched data in state
    } catch (error) {
      console.error("Error fetching theme data:", error);
    }

    
  };

  useEffect(()=>{
    fetchDetails();
  },[])

  return (
    <>
      <section className="sliderSec sliderInnerSec">
        <img src={sliderInner} alt="" />
        <div className="sliderInrHdng">
        <h2>Eco Clubs <span className="hdngBrkr">for Mission LiFE Themes</span></h2>
        </div>
      </section>
      <section className="sevenScopeSec reduceWasteSec">
        <div className="container-fluid">
          <span className="contact__shape-1"></span>
          <h2>Save <span className="hdngBrkr">Water</span> </h2>
          <button className="button green btn-login-signup loginBtnnewhm" style={{position:"absolute", right:"6%"}} onClick={()=>navigate(-1)} >Back</button>       
          <div className="sevenScopeBox">
            <ul className="themeGrid">
              {[
                { label: "Tabulate water wastage in school", icon: savewatericon1 },
                { label: "Check for leaks in flush systems, faucets, water pipes. Report to the eco-club teacher in charge", icon: savewatericon2 },
                { label: "Students along with their teachers can collect water from nearby storage systems/ponds & carry out tests to check water purity", icon: savewatericon3 },
                { label: "Water conservation rally along with the community", icon: savewatericon4 },
                { label: "Awareness sessions about rainwater harvesting system & its benefits", icon: savewatericon5 },
                { label: "Others", icon: savewatericon6 }
              ].map((theme, index) => (
                <li key={index} onClick={() => handleRoute(index)}>
                  <div className="themeBox orange6">
                    <div className="themeBoxIcn"><img src={theme.icon} alt="" /></div>
                    <div className="themeBoxCnt">{theme.label}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className='stackHolderSec sevenScopeSec reduceWasteSec'>
        <img className="slider__shape-13 stackholdrLf" src={leafIcn} alt="" />
        <div className="container-fluid">
          <span className="contact__shape-1"></span>
          {/* <h2>Stakeholders<span className="hdngBrkr">Involved</span></h2> */}
          <div className="stackHldrCntDiv">
  <div className="row">
    <div className="col-6 stackLft">
      <h2 className="sbHdng">participation AT A GLANCE</h2>
      <div className="stackLftIn">
        <ul>
          <li>
             States/UTs <span>{36}</span>
          </li>
          <li>
            Districts <span>{themeData ? themeData.districts : 0}</span>
          </li>
          <li>
            Total Schools <span>{themeData ? themeData.totalSchools : 0}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
        </div>
      </section>

    </>
  );
}

export default SaveWater;
